import React, {useState,} from 'react';
//import {Trash2} from "react-feather";
//import StundenNewEmployee from "./StundenNewEmployee";

function StundenReportEmployeeTable(props) {
    let [, setEmployeeData] = useState(props.tEmployeeData);
    //let [firstCoworkerStartTime,] = useState(props.defaultStartTime);
    //let [firstCoworkerEndTime,] = useState(props.defaultEndTime);


    /*function deleteEmployee(id) {
        props.setIsChange(false)
        let newEmployeeData = props.tEmployeeData.filter(emp => emp.id !== id);
        setEmployeeData(newEmployeeData);
        while (props.tEmployeeData.length > 0) {
            props.tEmployeeData.pop()
        }
        newEmployeeData.map((item) => {
            props.tEmployeeData.push(item);
        })
        let newState=props.stundenReportData
        newState.coworkers=props.tEmployeeData
        props.setStundenReportData(newState)


    }*/

    function getStundeMinuten(stunden,id) {

        let stunde = Math.floor(stunden);
        let minute = Math.round((stunden - stunde) * 60);

        if (minute === 60) {
            stunde++;
            minute = 0;
        }

        let output = stunde + " Stunde";
        if (stunde !== 1) {
            output += "n";
        }

        if (minute > 0) {
            output += " " + minute + " Minute";
            if (minute !== 1) {
                output += "n";
            }
        }


        let employeeIndex = props.tEmployeeData.findIndex((obj => obj.id === id));
        props.tEmployeeData[employeeIndex].workHours.duration = output

        return output;

    }


    const getEmployeeTableBody = (employeeData) => {

        return employeeData?.map((item) => (<tr key={item.id}>
            <td>{item.firstName}</td>
            <td>{item.lastName}</td>
            <td>{item.role}</td>
            <td><input type="text" className="table-input"
                       style={{width: "75px"}}
                       disabled={props.originState}
                       key={item.id}
                       value={item.workHours.startTime.substring(0, 5)}
                       onChange={(e) => {
                           let updateValue = e.target.value;
                           let newEmployeeData = props.tEmployeeData.map((emp) => {
                                   if (emp.id === item.id) {
                                       emp.workHours.startTime = updateValue
                                   }
                                   return emp;
                               }
                           );
                           setEmployeeData(newEmployeeData);
                       }}/>
                {" - "}
                <input type="text" className="table-input"
                       style={{width: "75px"}}
                       disabled={props.originState}
                       key={item.id}
                       value={item.workHours.endTime.substring(0, 5)}
                       onChange={(e) => {
                           let updateValue = e.target.value;
                           let newEmployeeData = props.tEmployeeData.map((emp) => {
                                   if (emp.id === item.id) {
                                       emp.workHours.endTime = updateValue
                                   }
                                   return emp;
                               }
                           );
                           setEmployeeData(newEmployeeData);
                       }}
                />
            </td>
            <td>
                {
                    getStundeMinuten(((new Date(`01/01/2023 ${item.workHours.endTime}`) -
                            new Date(`01/01/2023 ${item.workHours.startTime}`)) /
                        3600000
                    ),item.id)
                }
            </td>
            {/*<td
                style={{
                    display: props.originState ? "none" : "table-cell",
                    textAlign: "center",
                    verticalAlign: "middle",
                }}
            >
                <button className="btn btn-danger" onClick={() => deleteEmployee(item.id)}>
                    <Trash2/>
                </button>
            </td>*/}
        </tr>));
    };

    return (<>
            {/*<StundenNewEmployee
                setIsChange={props.setIsChange}
                originState={props.originState}
                employeeInfo={props.tEmployeeData}
                setEmployeeInfo={setEmployeeData}
                firstCoworkerEndTime={firstCoworkerEndTime}
                firstCoworkerStartTime={firstCoworkerStartTime}
            />*/}
            <br/>
            <table className="table handwai-white-text">
                <thead>
                <tr>
                    <th>Vorname</th>
                    <th>Nachname</th>
                    <th>Rolle</th>
                    <th>Arbeitszeit</th>
                    <th>Stunden</th>
                    {/*<th
                        style={{display: props.originState ? "none" : "table-cell"}}
                    >Löschen
                    </th>*/}
                </tr>
                </thead>
                <tbody>{getEmployeeTableBody(props.tEmployeeData)}</tbody>
            </table>
        </>
    );
}

export default StundenReportEmployeeTable;
